const formatPhoneNumber = (phoneNumber: string): string => {
    const sanitizedPhone = phoneNumber.replace(/\s+/g, '').replace('+', ''); // Remove spaces and '+'
    const formattedPhone = sanitizedPhone.match(/.{1,2}/g)?.join(' ') ?? ''; // Group into pairs and join

    return phoneNumber.startsWith('+') ? `+${formattedPhone}` : formattedPhone;
};

export default formatPhoneNumber;
